import { render, staticRenderFns } from "./SentenciasCreate.vue?vue&type=template&id=378f229e"
import script from "./SentenciasCreate.vue?vue&type=script&lang=js"
export * from "./SentenciasCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports